import React from 'react';
import { css } from '@emotion/css';

import imgBrancheFmcg from '../assets/media/branche-fmcg.png';
import imgBrancheIndustry from '../assets/media/branche-industry.png';
import imgBranchePe from '../assets/media/branche-pe.png';

const IndustryArea = () => {
    return (
        <div
            className={css({
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'stretch',
                gap: '5mm',
                marginTop: '2mm',
                marginBottom: '7mm',
                width: '100%',
            })}
        >
            <IndustryItem title="Industrie" image={imgBrancheIndustry}>
                <ul>
                    <li>Stückfertigung</li>
                    <li>Prozessfertigung</li>
                    <li>Dienstleister &amp; Handel</li>
                </ul>
            </IndustryItem>
            <IndustryItem title="FMCG" image={imgBrancheFmcg}>
                <ul>
                    <li>Hersteller</li>
                    <li>Einzel- &amp; Grosshandel</li>
                    <li>Logistik &amp; Transport</li>
                </ul>
            </IndustryItem>
            <IndustryItem title="Private Equity" image={imgBranchePe}>
                <ul>
                    <li>Private Equity</li>
                    <li>Geschäftsbanken</li>
                    <li>Investoren &amp; Family Offices</li>
                </ul>
            </IndustryItem>
        </div>
    );
};

const IndustryItem = ({ image, title, children }) => {
    return (
        <div
            className={css({
                flexGrow: 1,
                '& > ul': {
                    padding: 0,
                    paddingLeft: '6mm',
                    margin: 0,
                },
            })}
        >
            <img
                className={css({
                    maxWidth: '100%',
                    objectFit: 'cover',
                })}
                alt={title}
                src={image}
            />
            <h3
                className={css({
                    color: 'black',
                    marginTop: '1mm',
                })}
            >
                {title}
            </h3>
            {children}
        </div>
    );
};

export default IndustryArea;
